export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-comment-528447cb8cae9bc20988e7359341b085.svg";